// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3fQHE","disabled":"FileBtn_disabled__3JU7s","warn":"FileBtn_warn__3hAeb","fade":"FileBtn_fade__3ESjC"};